import { createSelector } from 'reselect';
import { initialState } from './reducer';

const selectGlobal = (state) => state.search || initialState;

const makeSelectSearchString = () => createSelector(selectGlobal, (searchState) => searchState.searchString);
const makeSelectFilterMenuStatus = () => createSelector(selectGlobal, (searchState) => searchState.filterMenuStatus);
const makeSelectFilterActive = () => createSelector(selectGlobal, (searchState) => searchState.filterActive);

// Structure
const makeSelectStructureFilterContent = () => createSelector(selectGlobal, (searchState) => searchState.structure);
const makeSelectStructureFilterId = () => createSelector(selectGlobal, (searchState) => searchState.structureFilterId);
const makeSelectStructureFilterComplex = () =>
  createSelector(selectGlobal, (searchState) => searchState.structureFilterComplex);
const makeSelectStructureFilterDataArray = () =>
  createSelector(selectGlobal, (searchState) => searchState.structureFilterDataArray);
const makeSelectStructureFilterReadable = () =>
  createSelector(selectGlobal, (searchState) => searchState.structureFilterReadable);
// Location
const makeSelectLocationFilterContent = () => createSelector(selectGlobal, (searchState) => searchState.location);
const makeSelectLocationFilterId = () => createSelector(selectGlobal, (searchState) => searchState.locationFilterId);
const makeSelectLocationFilterDataArray = () =>
  createSelector(selectGlobal, (searchState) => searchState.locationFilterDataArray);
const makeSelectLocationFilterReadable = () =>
  createSelector(selectGlobal, (searchState) => searchState.locationFilterReadable);
// Days
const makeSelectDaysFilterContent = () => createSelector(selectGlobal, (searchState) => searchState.days);
const makeSelectDaysFilterId = () => createSelector(selectGlobal, (searchState) => searchState.daysFilterId);
const makeSelectDaysFilterDataArray = () =>
  createSelector(selectGlobal, (searchState) => searchState.daysFilterDataArray);
// Time
const makeSelectTimeFilterContent = () => createSelector(selectGlobal, (searchState) => searchState.time);
const makeSelectTimeFilterId = () => createSelector(selectGlobal, (searchState) => searchState.timeFilterId);
const makeSelectTimeFilterDataArray = () =>
  createSelector(selectGlobal, (searchState) => searchState.timeFilterDataArray);
// Special
const makeSelectSpecialFilterContent = () => createSelector(selectGlobal, (searchState) => searchState.special);
const makeSelectSpecialFilterId = () => createSelector(selectGlobal, (searchState) => searchState.specialFilterId);
const makeSelectSpecialFilterDataArray = () =>
  createSelector(selectGlobal, (searchState) => searchState.specialFilterDataArray);

// Degree
const makeSelectDegreeFilterContent = () => createSelector(selectGlobal, (searchState) => searchState.degree);
const makeSelectDegreeFilterId = () => createSelector(selectGlobal, (searchState) => searchState.degreeFilterId);
const makeSelectDegreeFilterDataArray = () =>
  createSelector(selectGlobal, (searchState) => searchState.degreeFilterDataArray);
const makeSelectDegreeFilterReadable = () =>
  createSelector(selectGlobal, (searchState) => searchState.degreeFilterReadable);

// Niveau
const makeSelectNiveauFilterContent = () => createSelector(selectGlobal, (searchState) => searchState.niveau);
const makeSelectNiveauFilterId = () => createSelector(selectGlobal, (searchState) => searchState.niveauFilterId);
const makeSelectNiveauFilterDataArray = () =>
  createSelector(selectGlobal, (searchState) => searchState.niveauFilterDataArray);
const makeSelectNiveauFilterReadable = () =>
  createSelector(selectGlobal, (searchState) => searchState.niveauFilterReadable);

// Angebotsart (event type)
const makeSelectEventTypeFilterContent = () => createSelector(selectGlobal, (searchState) => searchState.eventType);
const makeSelectEventTypeFilterId = () => createSelector(selectGlobal, (searchState) => searchState.eventTypeFilterId);
const makeSelectEventTypeFilterDataArray = () =>
  createSelector(selectGlobal, (searchState) => searchState.eventTypeFilterDataArray);
const makeSelectEventTypeFilterReadable = () =>
  createSelector(selectGlobal, (searchState) => searchState.eventTypeFilterReadable);

export {
  makeSelectSearchString,
  makeSelectFilterMenuStatus,
  makeSelectFilterActive,
  // Structure
  makeSelectStructureFilterId,
  makeSelectStructureFilterContent,
  makeSelectStructureFilterComplex,
  makeSelectStructureFilterDataArray,
  makeSelectStructureFilterReadable,
  // Location
  makeSelectLocationFilterId,
  makeSelectLocationFilterContent,
  makeSelectLocationFilterDataArray,
  makeSelectLocationFilterReadable,
  // Days
  makeSelectDaysFilterContent,
  makeSelectDaysFilterId,
  makeSelectDaysFilterDataArray,
  // Time
  makeSelectTimeFilterContent,
  makeSelectTimeFilterId,
  makeSelectTimeFilterDataArray,
  // Special
  makeSelectSpecialFilterContent,
  makeSelectSpecialFilterId,
  makeSelectSpecialFilterDataArray,
  // Degree
  makeSelectDegreeFilterId,
  makeSelectDegreeFilterContent,
  makeSelectDegreeFilterDataArray,
  makeSelectDegreeFilterReadable,
  // Niveau
  makeSelectNiveauFilterId,
  makeSelectNiveauFilterContent,
  makeSelectNiveauFilterDataArray,
  makeSelectNiveauFilterReadable,
  // Angebotsart (event type)
  makeSelectEventTypeFilterId,
  makeSelectEventTypeFilterContent,
  makeSelectEventTypeFilterDataArray,
  makeSelectEventTypeFilterReadable,
};
